// extracted by mini-css-extract-plugin
module.exports = {"divider":"EidsrIntegration_divider__2Fv44","header":"EidsrIntegration_header__j9FL7","districtInput":"EidsrIntegration_districtInput__1IO-G"};